'use client';
import React from 'react';
import { TruckIcon, GlobeAltIcon, BuildingOffice2Icon, CubeIcon } from '@heroicons/react/24/outline';

interface Service {
    title: string;
    description: string;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    image: string;
    features: string[];
}

const services: Service[] = [
    {
        title: 'National Drayage',
        description: 'Import & export drayage execution from both rail and port, leveraging our network of over 300 power units and 1,500 chassis via JCT.',
        icon: TruckIcon,
        image: '/images/drayage.jpg',
        features: [
            'Import & export drayage from rail and port',
            'Network of 300+ power units',
            '1,500+ chassis availability',
            'Nationwide coverage'
        ]
    },
    {
        title: 'Transloading',
        description: 'Strategic pre-pull, secure storage, and grounding solutions with efficient transloading services for optimized supply chain operations.',
        icon: BuildingOffice2Icon,
        image: '/images/transloading1.jpg',
        features: [
            'Strategic pre-pull operations',
            'Secure storage solutions',
            'Grounding solutions',
            'Efficient cargo handling'
        ]
    },
    {
        title: 'Warehousing',
        description: 'Dedicated yard operations and comprehensive warehousing solutions with modern inventory management and destination management capabilities.',
        icon: CubeIcon,
        image: '/images/warehousing1.jpg',
        features: [
            'Dedicated yard operations',
            'Destination management',
            'Modern inventory systems',
            'Secure storage facilities'
        ]
    },
    {
        title: 'Domestic FTL',
        description: 'National capacity through our own assets and trusted partner network, ensuring reliable full truckload services across the country.',
        icon: GlobeAltIcon,
        image: '/images/ftl1.jpg',
        features: [
            'Own asset utilization',
            'Trusted partner network',
            'Nationwide coverage',
            'Reliable delivery times'
        ]
    }
];

const MainServices: React.FC = () => {
    return (
        <section className="py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {services.map((service, index) => (
                        <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                            <div className="relative h-64">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-40"></div>
                            </div>
                            <div className="p-8">
                                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                                    {service.title}
                                </h3>
                                <p className="text-gray-600 mb-6">
                                    {service.description}
                                </p>
                                <ul className="space-y-3">
                                    {service.features.map((feature, idx) => (
                                        <li key={idx} className="flex items-center text-gray-700">
                                            <svg className="h-5 w-5 text-[#29abe2] mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MainServices; 